export let today = new Date();        
export let year = today.getFullYear();      
export let weekNum = today.getUTCDay() >= 4 ? getWeekNumber(today): getWeekNumber(today) - 1;     
    
export let startYear = 2024;    
export let startWeek = 40;    
  
export let lastWeekNum;      
if(weekNum > 1) {      
    lastWeekNum = weekNum - 1;      
} else {      
    let lastYear = year - 1;      
    let jan1LastYear = new Date(Date.UTC(lastYear, 0, 1));      
    let jan1DayOfWeek = jan1LastYear.getUTCDay();      
    lastWeekNum = jan1DayOfWeek <= 2 ? 52 : 53;      
}      
  
export let lastWeekYear;      
if(weekNum > 1) {      
    lastWeekYear = year;      
} else {      
    lastWeekYear = year - 1;      
}      

// Function to get week number of a given date  
export function getWeekNumber(d) {    
    // Set the date to the start of the week in UTC  
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));    
    d.setUTCDate(d.getUTCDate() + 3 - (d.getUTCDay() + 6) % 7);    
    let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));    
    let weekNum = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);    
    return weekNum;    
}    
  
// Function to get start and end dates of a given week number in a particular year  
export function getWeekStartEnd(year, weekNum) {    
    let d = new Date(Date.UTC(year, 0, 1 + (weekNum - 1) * 7));    
    d.setUTCDate(d.getUTCDate() + 3 - (d.getUTCDay() + 6) % 7);    
    let start = new Date(d);    
    let end = new Date(d);    
    end.setUTCDate(end.getUTCDate() + 6);    
    start = start.toLocaleDateString();    
    end = end.toLocaleDateString();    
    return `${start} - ${end}`;    
}    
  
// Function to generate a list of all weeks from the start year and week number to last week's year and week number
export function generateWeeks(startYear, startWeek) {    
    let weeks = [];    
    for (let y = year; y >= startYear; y--) {    
        let jan1 = new Date(Date.UTC(y, 0, 1));    
        let jan1DayOfWeek = jan1.getUTCDay();    
        let maxWeeks = jan1DayOfWeek <= 2 ? 52 : 53;    
        for (let w = (y === year ? weekNum - 1 : maxWeeks); w >= (y === startYear ? startWeek : 1); w--) {    
            weeks.push({ week: w, year: y });    
        }    
    }    
    return weeks;    
}      
